import React from 'react';
import * as styles from './SearchHighlight.module.scss';

const EM_TAG_REGEX = /<\/?em>/g;

interface ExtensionSearchHighlightProps {
  text?: string | null;
}

const ExtensionSearchHighlight = ({ text }: ExtensionSearchHighlightProps) => {
  if (!text) return null;

  return (
    <>
      {text.split(EM_TAG_REGEX).map((part, i) => {
        if (i % 2 === 0) return part;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <em className={styles.highlight} key={i}>
            {part}
          </em>
        );
      })}
    </>
  );
};

export default ExtensionSearchHighlight;
